const przebieg = { t: 'Przebieg', type: 'range', name: 'przebieg', unit: 'km', hint: { url: '/mileage' }}
export default przebieg